import React, { useEffect, useState } from "react";
import HeroBanner from "../../../assets/svgs/employer_login_hero.png";
import NeoInsuranceLogo from "../../../assets/svgs/neoInsuranceLogoWhite_risk.svg";
import doubleCircle from "../../../assets/svgs/doupleCircle.svg";
import dotted from "../../../assets/svgs/dotted.svg";
import Building from "../../../assets/images/building.jpeg";
import { env } from "../../../config.json";
import { LargeButton } from "../../../components";
import { Ptag } from "../../../components/fonts";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Error,
  LoginContentWrapper,
  LoginPageWrapper,
  OverlayTint,
  PhoneInput,
  PhoneInputWrapper,
  SideImage,
} from "./styles";
import http from "../../../services/httpService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import BaseInput from "../../../components/BaseInput";
import BaseTextArea from "../../../components/UniversalComponents/BaseTextArea";
import { event } from "react-ga";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { stat } from "fs";
import MiddleText from "./middleText";
import { colors } from "../../../theme";

const EmployerLogin = () => {
  const location = useLocation();
  const [hrLogin, setHrLogin] = useState(false);
  const [phoneNo, setPhoneNo] = useState("");
  const [password, setPassword] = useState("");
  const [lading, setLoading] = useState("");
  const [email, setEmail] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [backendError, setBackendError] = useState("");
  const history = useHistory();
  console.log({ location });
  // const numberValidator = (event) => {
  //   removeError();
  //   const number = event.target.value;
  //   const cleanedStr = number.replace(/\D/g, "");
  //   setPhoneNo(cleanedStr);
  // };

  useEffect(() => {
    if (location) {
      const params = new URLSearchParams(location.search);
      const hrlogin = params.get("hrlogin");
      console.log({ hrlogin });
      hrlogin ? setHrLogin(true) : setHrLogin(false);
    }
  });
  const emailValidator = (event) => {
    removeError();
    setEmail(event.target.value);
  };
  const passwordValidator = (event) => {
    setPassword(event.target.value);
    console.log(event.target.value);
  };

  // const loginHandler = async () => {
  //   if (phoneNo.length !== 10) {
  //     setError("*Required");
  //     return;
  //   }
  //   try {
  //     await http.post("/phone/send_otp/", {
  //       phone: phoneNo,
  //       action: "LOGIN",
  //       business: true,
  //     });
  //     setupLocalStorage();
  //     history.push("/business/otp");
  //   } catch (err) {
  //     console.log({ err });
  //     setErrorSnackbar(true);
  //     //   alert("Some error has occured!");
  //   }
  // };

  const loginHandler = async () => {
    console.log({ password });
    // if (password !== 10) {
    //   setPasswordError("*Required");
    //   return;
    // }
    setLoading(true);
    const otp = password;
    if (hrLogin) {
      history.push("/business/reset-password", { email: email });
      return;
    }
    try {
      let { data } = await http.post("/phone/verify_employer_login/", {
        email: email,
        password: password,
      });
      data = data.data;
      const about = {
        name: data["company"] && data["company"]["company_name"],
        pincode: data["company"] && data["company"]["pincode"],
        numberOfEmployees:
          data["company"] && data["company"]["number_of_employees"],
        email: data["email"],
      };
      localStorage.setItem("uuid", data.id);
      const options = ["GMC", "GMC_M", "GPA", "GTL"];
      if (data.company.flex) {
        console.log("IN");
        localStorage.setItem("isFlex", true);
      } else if (options.includes(data.b_type)) {
        localStorage.setItem("flow", data.b_type);
      }
      localStorage.setItem("about", JSON.stringify(about));
      localStorage.removeItem("navigatingFrom");
      localStorage.setItem("marketplace_city", data["marketplace_city"]);
      localStorage.setItem("businessAccount", true);
      localStorage.setItem(
        "companyId",
        data["company"] && data["company"]["id"]
      );
      const loggingInFor = localStorage.getItem("logginginfor");
      if (data["company"] && data["company"]["userplan_id"]) {
        localStorage.setItem("userplan_id", data["company"]["userplan_id"]);
        localStorage.setItem("token", data.token);
        if (loggingInFor === "insurancepayment") {
          history.push("/business/payment");
          return;
        }
        history.push("/business/dashboard");
      } else if (
        data["company"] &&
        !data["company"]["userplan_id"] &&
        data["company"]["employee_collection_required"]
      ) {
        localStorage.setItem("token", data.token);
        history.push("/business/employee-registration-dashboard");
      } else {
        setLoading(false);
      }
    } catch (ex) {
      setLoading(false);
      setErrorSnackbar(true);
      setBackendError(ex.response.data);
      console.log(ex.response.data);
      if (ex.response && ex.response.status === 400) setLoading(false);
    }
  };

  const setupLocalStorage = () => {
    localStorage.setItem("navigatingFrom", "login");
    localStorage.setItem("phone", phoneNo);
  };

  const removeError = () => {
    setError("");
  };
  console.log(error);
  const useStyles = makeStyles({
    cookieAlert: {
      "& .MuiAlert-message": {
        fontSize: "14px",
      },
    },
  });

  const classes = useStyles();

  return (
    <>
      <Snackbar
        open={errorSnackbar}
        autoHideDuration={4000}
        onClose={() => setErrorSnackbar(false)}
      >
        <Alert severity="error" className={classes.cookieAlert}>
          {backendError}
        </Alert>
      </Snackbar>
      <LoginPageWrapper>
        <aside
          style={{
            position: "relative",
          }}
        >
          <img
            src={NeoInsuranceLogo}
            style={{
              position: "absolute",
              zIndex: "20",
              width: "240px",
              top: "60px",
              left: "40px",
              height: "auto",
            }}
          />
          <img
            src={dotted}
            style={{
              position: "absolute",
              zIndex: "20",
              height: "15%",
              opacity: "50%",
              width: "15%",
              top: "20%",
              left: "60%",
            }}
          />
          <img
            src={doubleCircle}
            style={{
              position: "absolute",
              zIndex: "20",
              height: "20%",
              opacity: "50%",
              width: "20%",
              bottom: "0px",
              left: "-2px",
            }}
          />
          <OverlayTint />
          <MiddleText />
          <SideImage src={Building} />
        </aside>
        <LoginContentWrapper>
          <div>
            <div style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column"
            }}>
              <Ptag fontSize="20px" fontWeight="700" marginTop="2em">
                Welcome!
              </Ptag>
              <Ptag fontSize="14px" fontWeight="500" marginTop="0.8em">
                Login to your account
              </Ptag>
            </div>
            <div
              style={{ display: "flex", gap: "2rem", flexDirection: "column" }}
            >
              <div>
                <Ptag
                  fontSize="16px"
                  fontWeight="500"
                  marginLeft="1rem"
                  marginBottom="1rem"
                  color={colors.neoFontColor}
                >
                  Email
                </Ptag>
                <PhoneInputWrapper>
                  <PhoneInput
                    type="tel"
                    value={email}
                    onChange={emailValidator}
                    pattern="[A-Za-z]{3}"
                  />
                  {error && <Error>{error}</Error>}
                </PhoneInputWrapper>
              </div>
              <div>
                <Ptag
                  fontSize="16px"
                  fontWeight="500"
                  marginTop="30px"
                  marginLeft="1rem"
                  marginBottom="1rem"
                  color={colors.neoFontColor}
                >
                  Password
                </Ptag>
                <PhoneInputWrapper>
                  <PhoneInput
                    type="password"
                    // value={password}
                    onChange={passwordValidator}
                    pattern="[A-Za-z]{3}"
                    maxLength="10"
                  />
                  {passwordError && <Error>{passwordError}</Error>}
                </PhoneInputWrapper>
              </div>
              {/* <Ptag
                fontSize="18px"
                fontWeight="700"
                marginLeft="1rem"
                marginBottom="1rem"
                color="#4A90E2"
                style={{ cursor: "pointer" }}
              >
                <u>Forget Password?</u>
              </Ptag> */}
            </div>
            {/* <BaseTextArea name={"email_address"} />
            <BaseTextArea name={"Password"} /> */}
            <LargeButton label="Login" onClick={() => loginHandler()} />
          </div>
        </LoginContentWrapper>
      </LoginPageWrapper>
    </>
  );
};

export default EmployerLogin;
